class IngredientsTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.ingredients-tabs__item-link');
    this.descriptions = this.querySelectorAll('.ingredients-tab__description');
    this.ingredients = this.querySelectorAll('.ingredient-item');

    this.items.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const groupId = tab.getAttribute('data-group-id');

        this.querySelectorAll('.ingredients-tabs__item').forEach((li) => li.classList.remove('active'));
        tab.parentElement.classList.add('active');

        this.descriptions.forEach((desc) => {
          desc.setAttribute('hidden', true)
          desc.classList.add('hidden');
        });
        const target = this.querySelector(tab.getAttribute('data-target'));
        if (target) {
          target.removeAttribute('hidden');
          target.classList.remove('hidden');
        } 

        this.ingredients.forEach((ingredient) => {
          if (ingredient.getAttribute('data-group-id') === groupId) {
            ingredient.removeAttribute('hidden');
            ingredient.classList.remove('hidden');
          } else {
            ingredient.setAttribute('hidden', true);
            ingredient.classList.add('hidden');
          }
        });
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('ingredients-tabs')) {
    customElements.define('ingredients-tabs', IngredientsTabs);
  }
});
